import aframe from "aframe";
import { bindEvent } from "aframe-event-decorators";

var instance;

aframe.registerComponent("instructions", {
  schema: {
    flashTime: { default: 500 },
    flashes: { default: 3 }
  },
  init() {
    instance = this;
    this.reset();
  },
  stop() {
    this.flashCount = this.data.flashes;
    this.isFlashing = false;
    this.el.object3D.visible = false;
  },
  reset() {
    this.timer = 0;
    this.flashCount = 0;
    this.isFlashing = false;
    this.el.object3D.visible = false;
  },
  tick(t, dt) {
    if (this.isFlashing) {
      if (this.flashCount >= this.data.flashes) {
        this.isFlashing = false;
        this.el.object3D.visible = false;
      } else {
        this.timer += dt;
        if (this.timer <= this.data.flashTime) {
          this.el.object3D.visible = true;
        } else if (this.timer <= 2 * this.data.flashTime) {
          this.el.object3D.visible = false;
        } else {
          this.timer -= 2 * this.data.flashTime;
          this.flashCount += 1;
        }
      }
    }
  },
  gamestatechanged: bindEvent({ target: "[game-state]" }, function(evt) {
    const newState = evt.detail;
    if (newState === "NewGame") {
      this.reset();
      this.isFlashing = true;
    }
  })
});

export default {
  get instance() {
    return instance;
  },
}
